(function () {
  'use strict';

  var currentTab = 'ios';
  var currentQuery = '';

  // Escape special regex chars in the search query
  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Build the device list HTML for the current tab and query
  function buildList() {
    var data = window.JE_COMPAT_DEVICES;
    if (!data || !data[currentTab]) return '';

    var brands = data[currentTab];
    var query = currentQuery.trim().toLowerCase();
    var re = query ? new RegExp(escapeRegex(query), 'gi') : null;
    var html = '';
    var totalMatches = 0;

    Object.keys(brands).forEach(function (brand) {
      var models = brands[brand];
      var matchedItems = [];
      var brandMatches = query && brand.toLowerCase().indexOf(query) !== -1;

      models.forEach(function (model) {
        if (!re || brandMatches || model.toLowerCase().indexOf(query) !== -1) {
          var display = re && !brandMatches
            ? model.replace(re, function (m) { return '<mark>' + m + '</mark>'; })
            : model;
          matchedItems.push('<li class="je-compat-model">' + display + '</li>');
        }
      });

      if (matchedItems.length > 0) {
        totalMatches += matchedItems.length;
        html +=
          '<div class="je-compat-brand">' +
          '<h3 class="je-compat-brand-name">' + brand + '</h3>' +
          '<ul class="je-compat-models">' + matchedItems.join('') + '</ul>' +
          '</div>';
      }
    });

    if (totalMatches === 0) {
      html =
        '<p class="je-compat-empty">No devices matched your search. Try a different model name.</p>';
    }

    return html;
  }

  function render() {
    var lists = document.querySelectorAll('.je-compat-list');
    var content = buildList();
    lists.forEach(function (el) {
      el.innerHTML = content;
    });
  }

  function setTab(tab) {
    currentTab = tab;
    currentQuery = '';

    // Update tab buttons across all checker instances on the page
    document.querySelectorAll('.je-compat-tab').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.tab === tab);
    });

    // Clear search inputs
    document.querySelectorAll('.je-compat-search').forEach(function (input) {
      input.value = '';
    });

    render();
  }

  function init() {
    // Tab clicks
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.je-compat-tab');
      if (tab && tab.dataset.tab) {
        setTab(tab.dataset.tab);
      }
    });

    // Search input
    document.addEventListener('input', function (e) {
      if (e.target.classList.contains('je-compat-search')) {
        currentQuery = e.target.value;
        render();
      }
    });

    // Modal open — triggered by .je-compat-trigger buttons, or by a link
    // pointing at #check-compatibility (used inside inline_richtext fields,
    // which strip class/aria attributes but keep href)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.je-compat-trigger, a[href="#check-compatibility"]');
      if (!trigger) return;
      e.preventDefault();
      var dialog = document.getElementById('je-compat-dialog');
      if (!dialog) return;

      // Reset state on open
      currentTab = 'ios';
      currentQuery = '';
      dialog.querySelectorAll('.je-compat-tab').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.tab === 'ios');
      });
      dialog.querySelectorAll('.je-compat-search').forEach(function (input) {
        input.value = '';
      });
      render();

      dialog.showModal();
    });

    // Modal close — close button
    document.addEventListener('click', function (e) {
      if (e.target.closest('.je-compat-close')) {
        var dialog = e.target.closest('.je-compat-dialog');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      }
    });

    // Modal close — click on backdrop (native dialog fires click on dialog element
    // when clicking outside the content area)
    document.addEventListener('click', function (e) {
      var dialog = e.target.closest('dialog.je-compat-dialog');
      if (!dialog) return;
      var rect = dialog.getBoundingClientRect();
      var outsideDialog =
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom;
      if (outsideDialog) dialog.close();
    });

    // Initial render
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
